/*!
  Based on code that is Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

/* Defines environment capabilities for to determine if executing in a browser, on the server, or some other environment */

export const isClient = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
)

export const canUseWorkers = typeof Worker !== 'undefined'

export const canUseEventListeners = isClient && !!(window.addEventListener || window.attachEvent)

export const canUseViewport = isClient && !!window.screen
